import { render } from "./PopupWalletWithdraw.vue?vue&type=template&id=43f0d1c2&scoped=true"
import script from "./PopupWalletWithdraw.vue?vue&type=script&lang=js"
export * from "./PopupWalletWithdraw.vue?vue&type=script&lang=js"

import "./PopupWalletWithdraw.vue?vue&type=style&index=0&id=43f0d1c2&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f0d1c2"]])

export default __exports__